module.exports = __webpack_public_path__ + "img/no-img.4aeb186d.svg";